"use strict";

const MinMax = function () {
  const getData = function ($container, all = false) {
    const data = {};
    $container.find(".min-max").each(function () {
      const $minMax = $(this);
      const $minInput = $minMax.find('[name*="[min]"]');
      const $maxInput = $minMax.find('[name*="[max]"]');

      if ($minInput.length > 0 && $maxInput.length > 0) {
        const name = $minMax.find("input:first").attr("name").split("[")[0];

        data[name] = {
          min: all ? "" : $minInput.val().replaceAll(",", ""),
          max: all ? "" : $maxInput.val().replaceAll(",", ""),
        };
      }
    });
    return data;
  };

  const setData = function ($container, data) {
    for (const name in data) {
      const values = data[name];
      $container.find(`[name="${name}[max]"]`).val(values?.max);
      $container.find(`[name="${name}[min]"]`).val(values?.min);
    }
  };

  const clear = function ($container, key) {
    $container.find(".min-max input[name^=" + key + "]").val("");
  };

  return {
    getData,
    setData,
    clear,
  };
};

module.exports = MinMax();
